'use client'

import { useRouter } from 'next/navigation'
import { useEffect } from 'react'
import ErrorRecoveryCard from './components/error-recovery-card'

interface ErrorProps {
  error: Error & { digest?: string; statusCode?: number }
  reset: () => void
}

export default function Error({ error, reset }: ErrorProps) {
  const router = useRouter()

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') router.push('/')
    }
    window.addEventListener('keydown', handleEscape)
    return () => window.removeEventListener('keydown', handleEscape)
  }, [router])

  return (
    <div className="flex min-h-screen flex-col bg-ocean">
      <div className="flex flex-grow flex-col items-center justify-center px-4 py-12">
        <ErrorRecoveryCard error={error} reset={reset} />
      </div>
    </div>
  )
}
